import { useState } from "react";
import { fileUrl } from "@/lib/api";
import { Button } from "@/components/ui/button";
import SignaturePad from "@/components/SignaturePad";
import { Signature, HardHat, User as UserIcon } from "@phosphor-icons/react";

export default function SignaturesTab({ chantierId, client, signaturesList, onChanged }) {
  const [sigOpen, setSigOpen] = useState(false);

  return (
    <div className="space-y-3">
      <div className="space-y-2 grid grid-cols-2 gap-2 !space-y-0">
        <Button onClick={() => setSigOpen(true)} className="bg-[#005CFF] hover:bg-[#0047CC] h-12 rounded-2xl" data-testid="open-signature-btn">
          <Signature size={18} weight="bold" /> Signature client
        </Button>
        <Button onClick={() => setSigOpen(true)} className="bg-emerald-500 hover:bg-emerald-600 h-12 rounded-2xl" data-testid="open-signature-tech-btn">
          <HardHat size={18} weight="bold" /> Signature intervenant
        </Button>
      </div>
      {signaturesList.length === 0 ? (
        <div className="rounded-2xl bg-white/[0.03] border border-dashed border-white/10 p-6 text-center text-white/40 text-sm">Aucune signature</div>
      ) : (
        <div className="space-y-2">
          {signaturesList.map((s) => {
            const isTech = s.signer_type === "intervenant";
            return (
              <div key={s.id} className="rounded-2xl bg-white/[0.03] border border-white/10 p-3 flex items-center gap-3" data-testid={`sig-${s.id}`}>
                <img src={fileUrl(s.id)} alt="signature" className="w-20 h-12 rounded-md bg-white object-contain" />
                <div className="flex-1 min-w-0">
                  <div className="flex items-center gap-1.5">
                    {isTech ? <HardHat size={12} className="text-emerald-400" weight="duotone" /> : <UserIcon size={12} className="text-[#005CFF]" weight="duotone" />}
                    <span className="text-[10px] uppercase tracking-widest" style={{ color: isTech ? "#10B981" : "#005CFF" }}>
                      {isTech ? "Intervenant" : "Client"}
                    </span>
                  </div>
                  <div className="font-medium truncate">{s.client_name}</div>
                  <div className="text-xs text-white/50">{new Date(s.created_at).toLocaleString("fr-FR")}</div>
                </div>
              </div>
            );
          })}
        </div>
      )}
      <SignaturePad
        open={sigOpen}
        onClose={() => setSigOpen(false)}
        chantierId={chantierId}
        defaultClientName={client?.name || ""}
        onSaved={() => { setSigOpen(false); onChanged(); }}
      />
    </div>
  );
}
